// ADR 0008: the language the analysis text is shown in. The interface itself
// stays English; only model-written and reviewed text is translated.
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type Lang = "en" | "pl";

export const LANGUAGE_NAME: Record<Lang, string> = { en: "English", pl: "Polish" };

interface LangState {
  lang: Lang;
  setLang: (lang: Lang) => void;
}

export const useLangStore = create<LangState>()(
  persist(
    (set) => ({
      lang: "en",
      setLang: (lang) => set({ lang }),
    }),
    { name: "ensovia-lang" },
  ),
);

export function useLang(): Lang {
  return useLangStore((s) => s.lang);
}
